import { createBrowserRouter, Navigate } from "react-router-dom";

import berserkirSvg from "@/assets/shields/BERSERKIR.svg?raw";
import geboSvg from "@/assets/shields/GEBO.svg?raw";
import isazSvg from "@/assets/shields/ISAZ.svg?raw";
import krossSvg from "@/assets/shields/KROSS.svg?raw";
import midgardSvg from "@/assets/shields/MIDGARD.svg?raw";
import norbaustaSvg from "@/assets/shields/NORBAUSTA.svg?raw";
import norbvesturSvg from "@/assets/shields/NORBVESTUR.svg?raw";
import stjarnaSvg from "@/assets/shields/STJARNA.svg?raw";
import uruzSvg from "@/assets/shields/URUZ.svg?raw";
import zuruSvg from "@/assets/shields/ZURU.svg?raw";

import coinSvg from "@/assets/runes/01 COIN.svg?raw";
import locketSvg from "@/assets/runes/02 LOCKET.svg?raw";
import prismSvg from "@/assets/runes/03 PRISM.svg?raw";
import slateSvg from "@/assets/runes/04 SLATE.svg?raw";
import earthSvg from "@/assets/runes/05 EARTH.svg?raw";
import hexSvg from "@/assets/runes/06 HEX.svg?raw";
import tomeSvg from "@/assets/runes/07 TOME.svg?raw";
import octaSvg from "@/assets/runes/08 OCTA.svg?raw";
import skySvg from "@/assets/runes/09 SKY.svg?raw";

import AuthGuard from "@/guards/AuthGuard";
import ShieldGuard from "@/guards/ShieldGuard";
import StaffGuard from "@/guards/StaffGuard";
import StreamTeamAcademyFeatureGuard from "@/guards/StreamTeamAcademyFeatureGuard";
import StreamTeamGuard from "@/guards/StreamTeamGuard";
import SuperuserGuard from "@/guards/SuperuserGuard";

import AssetsLayout from "@/layouts/(assets)/AssetsLayout";
import DashboardLayout from "@/layouts/(dashboard)/DashboardLayout";
import ForgeLayout from "@/layouts/(forge)/ForgeLayout";
import LonghouseLayout from "@/layouts/(longhouse)/LonghouseLayout";
import RuneForgeLayout from "@/layouts/(stream-team)/RuneForgeLayout";
import StreamTeamLayout from "@/layouts/(stream-team)/StreamTeamLayout";
import BaseLayout from "@/layouts/BaseLayout";

import RedirectToExternal from "@/components/RedirectToExternal";
import TwitchCallbackPage from "@/pages/(auth)/TwitchCallbackPage";
import DashboardPage from "@/pages/(dashboard)/DashboardPage";
import MyAccountPage from "@/pages/(dashboard)/my-account/MyAccountPage";
import ForgePage from "@/pages/(forge)/ForgePage";
import ForgeShieldTwoSelectionPage from "@/pages/(forge)/ForgeShieldTwoSelectionPage";
import FeatureFlagsPage from "@/pages/(longhouse)/FeatureFlagsPage";
import LonghousePage from "@/pages/(longhouse)/LonghousePage";
import StreamTeamAboutPage from "@/pages/(stream-team)/StreamTeamAboutPage";
import StreamTeamAcademyPage from "@/pages/(stream-team)/StreamTeamAcademyPage";
import StreamTeamEventDetailPage from "@/pages/(stream-team)/StreamTeamEventDetailPage";
import StreamTeamEventsPage from "@/pages/(stream-team)/StreamTeamEventsPage";
import StreamTeamHomePage from "@/pages/(stream-team)/StreamTeamHomePage";
import StreamTeamLeaderboardsPage from "@/pages/(stream-team)/StreamTeamLeaderboardsPage";
import StreamTeamLiveStreamsPage from "@/pages/(stream-team)/StreamTeamLiveStreamsPage";
import StreamTeamSchedulePage from "@/pages/(stream-team)/StreamTeamSchedulePage";
import StreamTeamTeamPage from "@/pages/(stream-team)/StreamTeamTeamPage";
import StreamerProfilePage from "@/pages/(stream-team)/StreamerProfilePage";
import AnniversaryPage from "@/pages/(wallhalla)/AnniversaryPage";
import WallhallaViewer from "@/pages/(wallhalla)/WallhallaPage";
import HomePage from "@/pages/HomePage";

import AlreadyHasRunestoneGuard from "@/guards/AlreadyHasRunestoneGuard";
import AlreadyHasShieldGuard from "@/guards/AlreadyHasShieldGuard";
import AlreadyHasShieldTwoGuard from "@/guards/AlreadyHasShieldTwoGuard";
import ShieldTwoEligibilityGuard from "@/guards/ShieldTwoEligibilityGuard";
import SubscribedGuard from "@/guards/SubscribedGuard";
import LeaderboardLayout from "@/layouts/(dashboard)/LeaderboardLayout";
import WithoutNavBarLayout from "@/layouts/WithoutNavBaseLayout";
import leaderboardApolloClient from "@/leaderboardApolloClient";
import ClanStandingsPage from "@/pages/(assets)/ClanStandingsPage";
import HunterKillScoreboardPage from "@/pages/(assets)/HunterKillScoreboardPage";
import LatestShieldPage from "@/pages/(assets)/LatestShieldPage";
import NewShieldPage from "@/pages/(assets)/NewShieldPage";
import ProfilePage from "@/pages/(dashboard)/ProfilePage";
import ClanPage from "@/pages/(dashboard)/leaderboards/ClanPage";
import LifetimePage from "@/pages/(dashboard)/leaderboards/LifetimePage";
import SeasonsPage from "@/pages/(dashboard)/leaderboards/SeasonsPage";
import PlayerProfilePage from "@/pages/(dashboard)/players/PlayerProfilePage";
import ForgeRunePage from "@/pages/(forge)/runes/ForgeRunePage";
import ForgeRuneSelectionPage from "@/pages/(forge)/runes/ForgeRuneSelectionPage";
import ForgeShieldTwoPage from "@/pages/(forge)/shields-two/ForgeShieldTwoPage";
import ForgeShieldPage from "@/pages/(forge)/shields/ForgeShieldPage";
import StreamSettingsPage from "@/pages/(longhouse)/StreamSettingsPage";
import UploadHypePrizesPage from "@/pages/(longhouse)/UploadHypePrizesPage";
import UploadPlayerAvatarsPage from "@/pages/(longhouse)/UploadPlayerAvatarsPage";
import UploadShieldsPage from "@/pages/(longhouse)/UploadShieldsPage";
import UploadWallhallaPage from "@/pages/(longhouse)/UploadWallhallaPage";
import AdminUserApiPage from "@/pages/(longhouse)/admin-user-api/AdminUserApiPage";
import ExaltedReforgePage from "@/pages/(longhouse)/exalted-reforge/ExaltedReforgePage";
import LonghouseInboxPage from "@/pages/(longhouse)/inbox/LonghouseInboxPage";
import AdminMessagingPage from "@/pages/(longhouse)/messaging/AdminMessagingPage";
import PlayersPage from "@/pages/(longhouse)/players/PlayersPage";
import SeasonManagementPage from "@/pages/(longhouse)/season-management/SeasonManagementPage";
import ShieldMateDetailPage from "@/pages/(longhouse)/shield-mates/ShieldMateDetailPage";
import ShieldMatesPage from "@/pages/(longhouse)/shield-mates/ShieldMatesPage";
import StreamDeckPage from "@/pages/(longhouse)/stream-deck/StreamDeckPage";
import StreamTeamLiveSessionAnalyticsPage from "@/pages/(longhouse)/stream-team/StreamTeamLiveSessionAnalyticsPage";
import StreamTeamMemberAnalyticsPage from "@/pages/(longhouse)/stream-team/StreamTeamMemberAnalyticsPage";
import StreamTeamPage from "@/pages/(longhouse)/stream-team/StreamTeamPage";
import SurveyAnalyticsPage from "@/pages/(longhouse)/surveys/SurveyAnalyticsPage";
import SurveyBuilderPage from "@/pages/(longhouse)/surveys/SurveyBuilderPage";
import SurveysPage from "@/pages/(longhouse)/surveys/SurveysPage";
import BackgroundTaskDetailPage from "@/pages/(longhouse)/background-tasks/BackgroundTaskDetailPage";
import BackgroundTasksPage from "@/pages/(longhouse)/background-tasks/BackgroundTasksPage";
import ChatLogsPage from "@/pages/(longhouse)/chat-logs/ChatLogsPage";
import TagImagesPage from "@/pages/(longhouse)/tag-images/TagImagesPage";
import TwitchConnectionsPage from "@/pages/(longhouse)/twitch-connections/TwitchConnectionsPage";
import TagHistoryPage from "@/pages/(longhouse)/tag-history/TagHistoryPage";
import VanderwoodStreamAnalyticsPage from "@/pages/(longhouse)/vanderwood/VanderwoodStreamAnalyticsPage";
import VanderwoodStreamsPage from "@/pages/(longhouse)/vanderwood/VanderwoodStreamsPage";
import WebhookDetailPage from "@/pages/(longhouse)/webhooks/WebhookDetailPage";
import WebhooksPage from "@/pages/(longhouse)/webhooks/WebhooksPage";
import VillageInboxPage from "@/pages/(village)/inbox/VillageInboxPage";
import SurveyPage from "@/pages/(village)/surveys/SurveyPage";
import SurveysListPage from "@/pages/(village)/surveys/SurveysListPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import SubscribePage from "@/pages/SubscribePage";
import { ApolloProvider } from "@apollo/client";

// Detect subdomain
const hostnameParts = window.location.hostname.split(".");
var subdomain = hostnameParts.length > 2 ? hostnameParts[0] : "main"; // 'main' for vanderheim.com

// Get host and protocol
const host_including_top_level_domain = window.location.host;
const protocol = window.location.protocol;

// Define routes for each subdomain
const routesForMain = [
    {
        path: "/",
        element: (
            <RedirectToExternal
                url={`${protocol}//village.${host_including_top_level_domain}`}
            />
        ),
    },
];

const routesForWallhalla = [
    {
        path: "/",
        element: <WallhallaViewer />,
    },
    {
        path: "/wallhalla-viewer",
        element: <AnniversaryPage />,
    },
    {
        path: "*",
        element: <NotFoundPage />,
    },
];

const routesForAssets = [
    {
        path: "/",
        element: <AssetsLayout />,
        children: [
            {
                path: "hunter-kill-scoreboard",
                element: <HunterKillScoreboardPage />,
            },
            {
                path: "clan-standings",
                element: <ClanStandingsPage />,
            },
            {
                path: "latest-shield",
                element: <NewShieldPage />,
            },
            {
                path: "latest-shields/:position",
                element: <LatestShieldPage />,
            },
        ],
    },
    {
        path: "*",
        element: <NotFoundPage />,
    },
];

const routesForStreamTeam = [
    {
        path: "/",
        element: <StreamTeamLayout />,
        children: [
            {
                index: true,
                element: <StreamTeamHomePage />,
            },
            {
                path: "about",
                element: <StreamTeamAboutPage />,
            },
            {
                path: "team",
                element: <StreamTeamTeamPage />,
            },
            {
                path: "academy",
                element: (
                    <StreamTeamAcademyFeatureGuard>
                        <StreamTeamAcademyPage />
                    </StreamTeamAcademyFeatureGuard>
                ),
            },
            {
                path: "team/:username",
                element: <StreamerProfilePage />,
            },
            {
                path: "schedule",
                element: <StreamTeamSchedulePage />,
            },
            {
                path: "live",
                element: <StreamTeamLiveStreamsPage />,
            },
            {
                path: "events",
                element: <StreamTeamEventsPage />,
            },
            {
                path: "events/:eventId",
                element: <StreamTeamEventDetailPage />,
            },
            {
                path: "leaderboards",
                element: <StreamTeamLeaderboardsPage />,
            },
        ],
    },
    {
        path: "*",
        element: <NotFoundPage />,
    },
];

const routesForVillage =
    process.env.NODE_ENV === "production"
        ? [
              {
                  path: "/",
                  element: <HomePage />,
              },
              {
                  path: "/auth/twitch/callback",
                  element: <TwitchCallbackPage />,
              },
              {
                  path: "/subscribe",
                  element: (
                      <AuthGuard>
                          <WithoutNavBarLayout>
                              <SubscribePage />
                          </WithoutNavBarLayout>
                      </AuthGuard>
                  ),
              },
              {
                  path: "/privacy-policy",
                  element: <PrivacyPolicyPage />,
              },
              {
                  path: "/forge",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <AlreadyHasShieldGuard>
                                  <WithoutNavBarLayout>
                                      <ForgeLayout />
                                  </WithoutNavBarLayout>
                              </AlreadyHasShieldGuard>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgePage />,
                      },
                      {
                          path: "shields/berserkir",
                          element: (
                              <ForgeShieldPage rawSvgContent={berserkirSvg} />
                          ),
                      },
                      {
                          path: "shields/midgard",
                          element: (
                              <ForgeShieldPage rawSvgContent={midgardSvg} />
                          ),
                      },
                      {
                          path: "shields/gebo",
                          element: <ForgeShieldPage rawSvgContent={geboSvg} />,
                      },
                      {
                          path: "shields/isaz",
                          element: <ForgeShieldPage rawSvgContent={isazSvg} />,
                      },
                      {
                          path: "shields/kross",
                          element: <ForgeShieldPage rawSvgContent={krossSvg} />,
                      },
                      {
                          path: "shields/norbausta",
                          element: (
                              <ForgeShieldPage rawSvgContent={norbaustaSvg} />
                          ),
                      },
                      {
                          path: "shields/norbvestur",
                          element: (
                              <ForgeShieldPage rawSvgContent={norbvesturSvg} />
                          ),
                      },
                      {
                          path: "shields/stjarna",
                          element: (
                              <ForgeShieldPage rawSvgContent={stjarnaSvg} />
                          ),
                      },
                      {
                          path: "shields/uruz",
                          element: <ForgeShieldPage rawSvgContent={uruzSvg} />,
                      },
                      {
                          path: "shields/zuru",
                          element: <ForgeShieldPage rawSvgContent={zuruSvg} />,
                      },
                  ],
              },
              {
                  path: "/forge-shield-two",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <ShieldTwoEligibilityGuard>
                                  <AlreadyHasShieldTwoGuard>
                                      <WithoutNavBarLayout>
                                          <ForgeLayout />
                                      </WithoutNavBarLayout>
                                  </AlreadyHasShieldTwoGuard>
                              </ShieldTwoEligibilityGuard>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgeShieldTwoSelectionPage />,
                      },
                      {
                          path: "shields/berserkir",
                          element: (
                              <ForgeShieldTwoPage
                                  rawSvgContent={berserkirSvg}
                              />
                          ),
                      },
                      {
                          path: "shields/midgard",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={midgardSvg} />
                          ),
                      },
                      {
                          path: "shields/gebo",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={geboSvg} />
                          ),
                      },
                      {
                          path: "shields/isaz",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={isazSvg} />
                          ),
                      },
                      {
                          path: "shields/kross",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={krossSvg} />
                          ),
                      },
                      {
                          path: "shields/norbausta",
                          element: (
                              <ForgeShieldTwoPage
                                  rawSvgContent={norbaustaSvg}
                              />
                          ),
                      },
                      {
                          path: "shields/norbvestur",
                          element: (
                              <ForgeShieldTwoPage
                                  rawSvgContent={norbvesturSvg}
                              />
                          ),
                      },
                      {
                          path: "shields/stjarna",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={stjarnaSvg} />
                          ),
                      },
                      {
                          path: "shields/uruz",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={uruzSvg} />
                          ),
                      },
                      {
                          path: "shields/zuru",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={zuruSvg} />
                          ),
                      },
                  ],
              },
              {
                  path: "/freeplay-forge",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <BaseLayout>
                                  <ForgeLayout />
                              </BaseLayout>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgePage playground={true} />,
                      },
                      {
                          path: "shields/berserkir",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={berserkirSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/midgard",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={midgardSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/gebo",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={geboSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/isaz",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={isazSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/kross",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={krossSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/norbausta",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={norbaustaSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/norbvestur",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={norbvesturSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/stjarna",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={stjarnaSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/uruz",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={uruzSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/zuru",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={zuruSvg}
                                  playground={true}
                              />
                          ),
                      },
                  ],
              },
              {
                  path: "/runestone-carving",
                  element: (
                      <AuthGuard>
                          <StreamTeamGuard>
                              <AlreadyHasRunestoneGuard>
                                  <WithoutNavBarLayout>
                                      <RuneForgeLayout />
                                  </WithoutNavBarLayout>
                              </AlreadyHasRunestoneGuard>
                          </StreamTeamGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgeRuneSelectionPage />,
                      },
                      {
                          path: "runes/coin",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={coinSvg}
                                  runeName="COIN"
                              />
                          ),
                      },
                      {
                          path: "runes/locket",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={locketSvg}
                                  runeName="LOCKET"
                              />
                          ),
                      },
                      {
                          path: "runes/prism",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={prismSvg}
                                  runeName="PRISM"
                              />
                          ),
                      },
                      {
                          path: "runes/slate",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={slateSvg}
                                  runeName="SLATE"
                              />
                          ),
                      },
                      {
                          path: "runes/earth",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={earthSvg}
                                  runeName="EARTH"
                              />
                          ),
                      },
                      {
                          path: "runes/hex",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={hexSvg}
                                  runeName="HEX"
                              />
                          ),
                      },
                      {
                          path: "runes/tome",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={tomeSvg}
                                  runeName="TOME"
                              />
                          ),
                      },
                      {
                          path: "runes/octa",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={octaSvg}
                                  runeName="OCTA"
                              />
                          ),
                      },
                      {
                          path: "runes/sky",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={skySvg}
                                  runeName="SKY"
                              />
                          ),
                      },
                  ],
              },
              {
                  path: "/dashboard",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <ShieldGuard>
                                  <BaseLayout>
                                      <DashboardLayout />
                                  </BaseLayout>
                              </ShieldGuard>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <DashboardPage />,
                      },
                      {
                          path: "profile",
                          element: <ProfilePage />,
                      },
                      {
                          path: "my-account",
                          element: <MyAccountPage />,
                      },
                      {
                          path: "players/:player_id",
                          element: <PlayerProfilePage />,
                      },
                      {
                          path: "inbox",
                          element: <VillageInboxPage />,
                      },

                      {
                          path: "leaderboards",
                          element: <LeaderboardLayout />,
                          children: [
                              {
                                  index: true,
                                  element: <Navigate to="lifetime" replace />,
                              },
                              {
                                  path: "lifetime",
                                  element: (
                                      <ApolloProvider
                                          client={leaderboardApolloClient}
                                      >
                                          <LifetimePage />,
                                      </ApolloProvider>
                                  ),
                              },
                              {
                                  path: "seasons",
                                  element: (
                                      <ApolloProvider
                                          client={leaderboardApolloClient}
                                      >
                                          <SeasonsPage />,
                                      </ApolloProvider>
                                  ),
                              },
                              {
                                  path: "clans",
                                  element: (
                                      <ApolloProvider
                                          client={leaderboardApolloClient}
                                      >
                                          <ClanPage />,
                                      </ApolloProvider>
                                  ),
                              },
                          ],
                      },
                      {
                          path: "surveys",
                          element: <SurveysListPage />,
                      },
                      {
                          path: "surveys/:id",
                          element: <SurveyPage />,
                      },
                  ],
              },
              {
                  path: "/longhouse",
                  element: (
                      <AuthGuard>
                          <StaffGuard>
                              <LonghouseLayout />
                          </StaffGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <LonghousePage />,
                      },
                      {
                          path: "upload-shields",
                          element: <UploadShieldsPage />,
                      },
                      {
                          path: "upload-avatars",
                          element: <UploadPlayerAvatarsPage />,
                      },
                      {
                          path: "upload-hype-prizes",
                          element: <UploadHypePrizesPage />,
                      },
                      {
                          path: "upload-wallhalla",
                          element: <UploadWallhallaPage />,
                      },
                      {
                          path: "stream-settings",
                          element: <StreamSettingsPage />,
                      },
                      {
                          path: "stream-deck",
                          element: <StreamDeckPage />,
                      },
                      {
                          path: "stream-team",
                          element: <StreamTeamPage />,
                      },
                      {
                          path: "stream-team/:memberId",
                          element: <StreamTeamMemberAnalyticsPage />,
                      },
                      {
                          path: "stream-team/:memberId/sessions/:sessionId",
                          element: <StreamTeamLiveSessionAnalyticsPage />,
                      },
                      {
                          path: "vanderwood-streams",
                          element: <VanderwoodStreamsPage />,
                      },
                      {
                          path: "vanderwood-streams/:sessionId",
                          element: <VanderwoodStreamAnalyticsPage />,
                      },
                      {
                          path: "shield-mates",
                          element: <ShieldMatesPage />,
                      },
                      {
                          path: "shield-mates/:player_id",
                          element: <ShieldMateDetailPage />,
                      },
                      {
                          path: "players",
                          element: <PlayersPage />,
                      },
                      {
                          path: "messaging",
                          element: <AdminMessagingPage />,
                      },
                      {
                          path: "admin-user-api",
                          element: <AdminUserApiPage />,
                      },
                      {
                          path: "feature-flags",
                          element: (
                              <SuperuserGuard>
                                  <FeatureFlagsPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "tag-images",
                          element: (
                              <SuperuserGuard>
                                  <TagImagesPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "twitch-connections",
                          element: (
                              <SuperuserGuard>
                                  <TwitchConnectionsPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "inbox",
                          element: <LonghouseInboxPage />,
                      },
                      {
                          path: "season-management",
                          element: <SeasonManagementPage />,
                      },
                      {
                          path: "tag-history",
                          element: <TagHistoryPage />,
                      },
                      {
                          path: "chat-logs",
                          element: <ChatLogsPage />,
                      },
                      {
                          path: "background-tasks",
                          element: (
                              <SuperuserGuard>
                                  <BackgroundTasksPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "background-tasks/:taskId",
                          element: (
                              <SuperuserGuard>
                                  <BackgroundTaskDetailPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "exalted-reforge",
                          element: <ExaltedReforgePage />,
                      },
                      {
                          path: "webhooks",
                          element: <WebhooksPage />,
                      },
                      {
                          path: "webhooks/:webhook_id",
                          element: <WebhookDetailPage />,
                      },
                      {
                          path: "surveys",
                          element: <SurveysPage />,
                      },
                      {
                          path: "surveys/new",
                          element: <SurveyBuilderPage />,
                      },
                      {
                          path: "surveys/:id/edit",
                          element: <SurveyBuilderPage />,
                      },
                      {
                          path: "surveys/:id/analytics",
                          element: <SurveyAnalyticsPage />,
                      },
                  ],
              },
              {
                  path: "*",
                  element: <NotFoundPage />,
              },
          ]
        : [
              {
                  path: "/",
                  element: <HomePage />,
              },
              {
                  path: "/auth/twitch/callback",
                  element: <TwitchCallbackPage />,
              },
              {
                  path: "/subscribe",
                  element: (
                      <AuthGuard>
                          <WithoutNavBarLayout>
                              <SubscribePage />
                          </WithoutNavBarLayout>
                      </AuthGuard>
                  ),
              },
              {
                  path: "/privacy-policy",
                  element: <PrivacyPolicyPage />,
              },
              {
                  path: "/forge",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <AlreadyHasShieldGuard>
                                  <WithoutNavBarLayout>
                                      <ForgeLayout />
                                  </WithoutNavBarLayout>
                              </AlreadyHasShieldGuard>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgePage />,
                      },
                      {
                          path: "shields/berserkir",
                          element: (
                              <ForgeShieldPage rawSvgContent={berserkirSvg} />
                          ),
                      },
                      {
                          path: "shields/midgard",
                          element: (
                              <ForgeShieldPage rawSvgContent={midgardSvg} />
                          ),
                      },
                      {
                          path: "shields/gebo",
                          element: <ForgeShieldPage rawSvgContent={geboSvg} />,
                      },
                      {
                          path: "shields/isaz",
                          element: <ForgeShieldPage rawSvgContent={isazSvg} />,
                      },
                      {
                          path: "shields/kross",
                          element: <ForgeShieldPage rawSvgContent={krossSvg} />,
                      },
                      {
                          path: "shields/norbausta",
                          element: (
                              <ForgeShieldPage rawSvgContent={norbaustaSvg} />
                          ),
                      },
                      {
                          path: "shields/norbvestur",
                          element: (
                              <ForgeShieldPage rawSvgContent={norbvesturSvg} />
                          ),
                      },
                      {
                          path: "shields/stjarna",
                          element: (
                              <ForgeShieldPage rawSvgContent={stjarnaSvg} />
                          ),
                      },
                      {
                          path: "shields/uruz",
                          element: <ForgeShieldPage rawSvgContent={uruzSvg} />,
                      },
                      {
                          path: "shields/zuru",
                          element: <ForgeShieldPage rawSvgContent={zuruSvg} />,
                      },
                  ],
              },
              {
                  path: "/forge-shield-two",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <ShieldTwoEligibilityGuard>
                                  <AlreadyHasShieldTwoGuard>
                                      <WithoutNavBarLayout>
                                          <ForgeLayout />
                                      </WithoutNavBarLayout>
                                  </AlreadyHasShieldTwoGuard>
                              </ShieldTwoEligibilityGuard>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgeShieldTwoSelectionPage />,
                      },
                      {
                          path: "shields/berserkir",
                          element: (
                              <ForgeShieldTwoPage
                                  rawSvgContent={berserkirSvg}
                              />
                          ),
                      },
                      {
                          path: "shields/midgard",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={midgardSvg} />
                          ),
                      },
                      {
                          path: "shields/gebo",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={geboSvg} />
                          ),
                      },
                      {
                          path: "shields/isaz",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={isazSvg} />
                          ),
                      },
                      {
                          path: "shields/kross",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={krossSvg} />
                          ),
                      },
                      {
                          path: "shields/norbausta",
                          element: (
                              <ForgeShieldTwoPage
                                  rawSvgContent={norbaustaSvg}
                              />
                          ),
                      },
                      {
                          path: "shields/norbvestur",
                          element: (
                              <ForgeShieldTwoPage
                                  rawSvgContent={norbvesturSvg}
                              />
                          ),
                      },
                      {
                          path: "shields/stjarna",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={stjarnaSvg} />
                          ),
                      },
                      {
                          path: "shields/uruz",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={uruzSvg} />
                          ),
                      },
                      {
                          path: "shields/zuru",
                          element: (
                              <ForgeShieldTwoPage rawSvgContent={zuruSvg} />
                          ),
                      },
                  ],
              },
              {
                  path: "/freeplay-forge",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <BaseLayout>
                                  <ForgeLayout />
                              </BaseLayout>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgePage playground={true} />,
                      },
                      {
                          path: "shields/berserkir",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={berserkirSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/midgard",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={midgardSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/gebo",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={geboSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/isaz",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={isazSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/kross",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={krossSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/norbausta",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={norbaustaSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/norbvestur",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={norbvesturSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/stjarna",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={stjarnaSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/uruz",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={uruzSvg}
                                  playground={true}
                              />
                          ),
                      },
                      {
                          path: "shields/zuru",
                          element: (
                              <ForgeShieldPage
                                  rawSvgContent={zuruSvg}
                                  playground={true}
                              />
                          ),
                      },
                  ],
              },
              {
                  path: "/runestone-carving",
                  element: (
                      <AuthGuard>
                          <StreamTeamGuard>
                              <AlreadyHasRunestoneGuard>
                                  <WithoutNavBarLayout>
                                      <RuneForgeLayout />
                                  </WithoutNavBarLayout>
                              </AlreadyHasRunestoneGuard>
                          </StreamTeamGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <ForgeRuneSelectionPage />,
                      },
                      {
                          path: "runes/coin",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={coinSvg}
                                  runeName="COIN"
                              />
                          ),
                      },
                      {
                          path: "runes/locket",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={locketSvg}
                                  runeName="LOCKET"
                              />
                          ),
                      },
                      {
                          path: "runes/prism",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={prismSvg}
                                  runeName="PRISM"
                              />
                          ),
                      },
                      {
                          path: "runes/slate",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={slateSvg}
                                  runeName="SLATE"
                              />
                          ),
                      },
                      {
                          path: "runes/earth",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={earthSvg}
                                  runeName="EARTH"
                              />
                          ),
                      },
                      {
                          path: "runes/hex",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={hexSvg}
                                  runeName="HEX"
                              />
                          ),
                      },
                      {
                          path: "runes/tome",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={tomeSvg}
                                  runeName="TOME"
                              />
                          ),
                      },
                      {
                          path: "runes/octa",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={octaSvg}
                                  runeName="OCTA"
                              />
                          ),
                      },
                      {
                          path: "runes/sky",
                          element: (
                              <ForgeRunePage
                                  rawSvgContent={skySvg}
                                  runeName="SKY"
                              />
                          ),
                      },
                  ],
              },
              {
                  path: "/dashboard",
                  element: (
                      <AuthGuard>
                          <SubscribedGuard>
                              <ShieldGuard>
                                  <BaseLayout>
                                      <DashboardLayout />
                                  </BaseLayout>
                              </ShieldGuard>
                          </SubscribedGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <DashboardPage />,
                      },
                      {
                          path: "profile",
                          element: <ProfilePage />,
                      },
                      {
                          path: "my-account",
                          element: <MyAccountPage />,
                      },
                      {
                          path: "players/:player_id",
                          element: <PlayerProfilePage />,
                      },
                      {
                          path: "inbox",
                          element: <VillageInboxPage />,
                      },

                      {
                          path: "leaderboards",
                          element: <LeaderboardLayout />,
                          children: [
                              {
                                  index: true,
                                  element: <Navigate to="lifetime" replace />,
                              },
                              {
                                  path: "lifetime",
                                  element: (
                                      <ApolloProvider
                                          client={leaderboardApolloClient}
                                      >
                                          <LifetimePage />,
                                      </ApolloProvider>
                                  ),
                              },
                              {
                                  path: "seasons",
                                  element: (
                                      <ApolloProvider
                                          client={leaderboardApolloClient}
                                      >
                                          <SeasonsPage />,
                                      </ApolloProvider>
                                  ),
                              },
                              {
                                  path: "clans",
                                  element: (
                                      <ApolloProvider
                                          client={leaderboardApolloClient}
                                      >
                                          <ClanPage />,
                                      </ApolloProvider>
                                  ),
                              },
                          ],
                      },
                      {
                          path: "surveys",
                          element: <SurveysListPage />,
                      },
                      {
                          path: "surveys/:id",
                          element: <SurveyPage />,
                      },
                  ],
              },
              {
                  path: "/longhouse",
                  element: (
                      <AuthGuard>
                          <StaffGuard>
                              <LonghouseLayout />
                          </StaffGuard>
                      </AuthGuard>
                  ),
                  children: [
                      {
                          index: true,
                          element: <LonghousePage />,
                      },
                      {
                          path: "upload-shields",
                          element: <UploadShieldsPage />,
                      },
                      {
                          path: "upload-avatars",
                          element: <UploadPlayerAvatarsPage />,
                      },
                      {
                          path: "upload-hype-prizes",
                          element: <UploadHypePrizesPage />,
                      },
                      {
                          path: "upload-wallhalla",
                          element: <UploadWallhallaPage />,
                      },
                      {
                          path: "stream-settings",
                          element: <StreamSettingsPage />,
                      },
                      {
                          path: "admin-user-api",
                          element: <AdminUserApiPage />,
                      },
                      {
                          path: "feature-flags",
                          element: (
                              <SuperuserGuard>
                                  <FeatureFlagsPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "tag-images",
                          element: (
                              <SuperuserGuard>
                                  <TagImagesPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "twitch-connections",
                          element: (
                              <SuperuserGuard>
                                  <TwitchConnectionsPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "stream-deck",
                          element: <StreamDeckPage />,
                      },
                      {
                          path: "stream-team",
                          element: <StreamTeamPage />,
                      },
                      {
                          path: "stream-team/:memberId",
                          element: <StreamTeamMemberAnalyticsPage />,
                      },
                      {
                          path: "stream-team/:memberId/sessions/:sessionId",
                          element: <StreamTeamLiveSessionAnalyticsPage />,
                      },
                      {
                          path: "vanderwood-streams",
                          element: <VanderwoodStreamsPage />,
                      },
                      {
                          path: "vanderwood-streams/:sessionId",
                          element: <VanderwoodStreamAnalyticsPage />,
                      },
                      {
                          path: "shield-mates",
                          element: <ShieldMatesPage />,
                      },
                      {
                          path: "shield-mates/:player_id",
                          element: <ShieldMateDetailPage />,
                      },
                      {
                          path: "players",
                          element: <PlayersPage />,
                      },
                      {
                          path: "messaging",
                          element: <AdminMessagingPage />,
                      },
                      {
                          path: "inbox",
                          element: <LonghouseInboxPage />,
                      },
                      {
                          path: "season-management",
                          element: <SeasonManagementPage />,
                      },
                      {
                          path: "tag-history",
                          element: <TagHistoryPage />,
                      },
                      {
                          path: "chat-logs",
                          element: <ChatLogsPage />,
                      },
                      {
                          path: "background-tasks",
                          element: (
                              <SuperuserGuard>
                                  <BackgroundTasksPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "background-tasks/:taskId",
                          element: (
                              <SuperuserGuard>
                                  <BackgroundTaskDetailPage />
                              </SuperuserGuard>
                          ),
                      },
                      {
                          path: "exalted-reforge",
                          element: <ExaltedReforgePage />,
                      },
                      {
                          path: "webhooks",
                          element: <WebhooksPage />,
                      },
                      {
                          path: "webhooks/:webhook_id",
                          element: <WebhookDetailPage />,
                      },
                      {
                          path: "surveys",
                          element: <SurveysPage />,
                      },
                      {
                          path: "surveys/new",
                          element: <SurveyBuilderPage />,
                      },
                      {
                          path: "surveys/:id/edit",
                          element: <SurveyBuilderPage />,
                      },
                      {
                          path: "surveys/:id/analytics",
                          element: <SurveyAnalyticsPage />,
                      },
                  ],
              },
              {
                  path: "*",
                  element: <NotFoundPage />,
              },
          ];

// Select the routes based on the detected subdomain
let selectedRoutes;

// Set anything sent to https://f5dd-2a00-23a8-4ca1-2700-1142-82be-dd34-a05f.ngrok-free.app/ to the village routes, for testing purposes, set subdomain to "village"
// Set anything sent to http://localhost:5173/ to the village routes, for testing purposes, set subdomain to "village"

if (process.env.NODE_ENV === "development") {
    const isNgrok = host_including_top_level_domain.includes("ngrok-free.app");
    const isLocalhost = host_including_top_level_domain.includes("localhost");

    if (isNgrok) {
        subdomain = "village";
    }

    if (isLocalhost) {
        subdomain = "village";
    }
}

switch (subdomain) {
    case "wallhalla":
        selectedRoutes = routesForWallhalla;
        break;
    case "village":
        selectedRoutes = routesForVillage;
        break;
    case "assets":
        selectedRoutes = routesForAssets;
        break;
    case "ravenguard":
        selectedRoutes = routesForStreamTeam;
        break;
    default:
        selectedRoutes = routesForMain; // Default to main domain routes
}

// Create the router with the selected routes
export const router = createBrowserRouter(selectedRoutes);
